import { useEffect, useState, useRef } from 'react'
import { useQuery } from '@apollo/client'
import moment from 'moment'
import Box from '../../Global/Box'
import ProgressBarStatusReport from '../../Global/ProgressBarStatusReport'
import { GET_ALL_TIME_LINES_BY_CATEGORY_AND_DOCUMENT_ID } from '../../../graphql/Catalog/Timeline/timelines'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'

export const TimeLines = ({
  document_id,
  category = 'reports',
  withCard = true,
}) => {
  const [timeLine, setTimeLine] = useState(null)
  const boxScroll = useRef()

  /* TIMELINEs DATA */
  const { data, loading, error } = useQuery(
    GET_ALL_TIME_LINES_BY_CATEGORY_AND_DOCUMENT_ID,
    {
      variables: {
        document_id: parseInt(document_id ? document_id : 0),
        category,
      },
      fetchPolicy: 'no-cache',
    }
  )

  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({ mode: 'error', message: error.message })
      let list = []
      data.getAllTimelinesByCategoryAndDocumentId.map((timeData) => {
        list.push({
          user: timeData?.UserOfTimeline?.name
            ? timeData?.UserOfTimeline?.name
            : '--',
          charge: timeData?.UserOfTimeline?.JobPositionOfUser?.name
            ? timeData.UserOfTimeline.JobPositionOfUser?.name
            : '',
          date: moment(timeData?.date_status).format('dddd D[,] MMMM YYYY[,]'),
          time: moment(timeData?.date_status).format('hh:mm a'),
          current_status: timeData?.StatusOfTimeline,
          text: timeData?.text,
        })
        return true
      })
      setTimeLine(list)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading, error])

  useEffect(() => {
    if (boxScroll) {
      const element = boxScroll.current
      element.scrollTop = element.scrollHeight
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boxScroll, timeLine])

  const splitText = (text) => {
    if (!text.includes('-')) return text
    const textSplit = text.split('\n')

    const textSplitLength = textSplit.length

    const content = textSplit.map((item, idx) => {
      if (item === '') return
      return (
        <span
          style={{
            color: '#000',
          }}
          key={idx}
        >
          {item.split('-').map((item, idx) => {
            if (idx === 0) return item
            return (
              <span
                style={{
                  color: '#000',
                }}
                key={idx}
                // className="text-muted"
              >
                - {item}
              </span>
            )
          })}
          <br />
        </span>
      )
    })

    return content
  }

  return (
    <>
      <Box
        withCard={withCard}
        title="Historial de movimientos"
        classNameHeader="card-header py-1"
        content={
          <div className="timeLine-body" ref={boxScroll}>
            {timeLine?.length > 0 ? (
              <ul>
                {timeLine.map((item, idx) => (
                  <li className="" key={idx}>
                    <i className={`fas fa-circle fa-xs mr-1`} />
                    {item?.current_status && (
                      <>
                        <span className="title-details">
                          El estado cambio a
                        </span>
                        <br />
                        <ProgressBarStatusReport
                          statusReport={item.current_status}
                        />
                      </>
                    )}

                    {item?.text && (
                      <>
                        <span className="content-details">
                          {splitText(item.text)}
                        </span>
                      </>
                    )}

                    {item?.user && (
                      <span className="content-details">
                        {item.user} {item?.charge && `(${item.charge})`}
                      </span>
                    )}

                    {item?.date && item?.time && (
                      <span className="mt-1" id="time">
                        {item.date}{' '}
                        <span style={{ textTransform: 'uppercase' }}>
                          {item.time}.
                        </span>
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <ul>
                <li key="noTime">
                  <h6 id="time">--/--/---- --:--</h6>
                  <h5>
                    <i className="fas fa-circle fa-xs"></i>
                    Inicio
                  </h5>
                  <h6>Aún no hay movimientos</h6>
                </li>
              </ul>
            )}
          </div>
        }
      />
    </>
  )
}
export default TimeLines
